import { SearchEntryDto } from '../_generated/api/search'
import { buildSearchLink } from '../tools/link'
import ApiModel from './ApiModel'

export default class SearchResult extends ApiModel<SearchEntryDto> {
    get ancestorId() {
        return this.relationId ?? this.domainId
    }

    get name() {
        return this.data.name ?? ''
    }

    get domainId() {
        return this.data.domainId ?? ''
    }

    get domainType() {
        return this.data.domainType ?? ''
    }

    get aggregateId() {
        return this.data.aggregateId ?? ''
    }

    get relationId() {
        return this.data.relationId ?? undefined
    }

    get date() {
        const date = this.data.date
        return date ? new Date(date) : undefined
    }

    get searchLink() {
        return buildSearchLink(this.domainType, this.domainId)
    }

    asAncestor() {
        return {
            id: this.domainId,
            link: this.searchLink,
            name: this.name,
        }
    }
}
